export default "__VITE_PUBLIC_ASSET__df23e197__"